import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppBootstrap, AppBootstrapStatus } from './AppBootstrap';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

AppBootstrap().then((status) => {
  if (status === AppBootstrapStatus.SUCCESS) {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
});
